module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-sub"
  }, [(!_vm.category) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n    Loading...\n  ")]) : (Object.keys(_vm.categoryMap).length > 0 && !!_vm.groupId) ? _c('div', {
    staticClass: "nav-section"
  }, [_c('h3', {
    staticClass: "nav-title"
  }, [_vm._v(_vm._s(_vm.categoryMap[_vm.groupId].title))]), _vm._v(" "), _c('ul', {
    staticClass: "nav-list"
  }, _vm._l((_vm.categoryMap[_vm.groupId].itemList), function(item) {
    return _c('li', [(item.groupId != 999) ? _c('router-link', {
      attrs: {
        "to": '/' + _vm.lan + '/detail/' + _vm.categoryMap[_vm.groupId].groupId + '/' + item.id
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (item.groupId == 999) ? _c('router-link', {
      attrs: {
        "to": '/' + _vm.lan + '/scene/' + _vm.categoryMap[_vm.groupId].groupId + '/' + item.id
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()], 1)
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40873e84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/components/CategoryList.vue
// module id = 711
// module chunks = 4